export const data = {
    dCells: [
        {
            id: '1-1',
            color: 'blueLight',
        },
        {
            id: '1-16',
            color: 'white',
        },
        {
            id: '1-12',
            color: 'orange',
        },
        {
            id: '5-1',
            color: 'orange',
        },
        {
            id: '5-8',
            color: 'beige',
        },
        {
            id: '5-9',
            color: 'white',
        },
        {
            id: '5-16',
            color: 'beige',
        },
        
    ],
    mCells: [
        {
            id: '5-7',
            color: 'blueLight',
        },
        {
            id: '6-6',
            color: 'beige',
        },
        {
            id: '6-8',
            color: 'orange',
        },
        {
            id: '7-4',
            color: 'orange',
        },
        {
            id: '7-7',
            color: 'blueLight',
        },
        {
            id: '8-3',
            color: 'blueLight',
        },
        {
            id: '8-4',
            color: 'hue',
        },
        {
            id: '8-8',
            color: 'orange',
        },
        {
            id: '11-2',
            color: 'blueLight',
        },
        {
            id: '11-8',
            color: 'hue',
        },
        {
            id: '12-1',
            color: 'orange',
        },
        {
            id: '12-4',
            color: 'black',
        },
        {
            id: '12-5',
            color: 'black',
        },
        {
            id: '12-7',
            color: 'blueLight',
        },
        {
            id: '12-8',
            color: 'black',
        },
    ]
}